import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
  BrowserRouter,
} from "react-router-dom";
import React, { useState, useEffect } from "react";

import Landing from "../pages/Landing";
// import CreditCard from "../pages/CreditCard";
import HDFCPrivacyPolicy from "../pages/HDFCPrivacyPolicy";
import ConsentV1 from "../pages/ConsentV1";
import ConsentV2 from "../pages/ConsentV2";
import NewJourney from "../pages/Journey";
import { SideNavBar } from "../utils/SideNavBar";
import Navbar from "../utils/sidebarRes";
import "../styles/index.css";

// import CreditScorePage from "../pages/BuroRecords/CreditScore";
import CreditScoreRes from "../pages/BuroRecords/creditScoreRes";
import AccountDetails from "../pages/BuroRecords/accountsDetails"
import Home from "../pages/BuroRecords";

// import SideNavBar from "../utils/sidebar";
// import OldJourney from "../oldJourney/Journey/JourneyPage";

export default function Router() {
  const [navVisible, showNavbar] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // console.log("location", location.pathname);

  // useEffect(() => {
  //   const currentRoute = window.location.pathname;
  //   showNavbar(currentRoute === '/customers/dashboard');
  // }, []);

  return (
    <div className="Apps">
      {/* <Navbar visible={navVisible} show={showNavbar} /> */}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/customers"
          element={
            // <div className={!navVisible ? "page" : "page page-with-navbar"}>
            <NewJourney />
            // </div>
          }
        />
        {/* <Route path="/" element={<Navigate to="/customers/dashboard" />} /> */}
        <Route
          path="/customers/home"
          element={
            <div>
              <Home />
            </div>
          }
        >
        <Route
            path="dashboard"
            element={
              <div className={!navVisible ? "page" : "page page-with-navbar"}>
                {/* <CreditScorePage /> */}
                <CreditScoreRes/>
              </div>
            }
          />
          <Route
            path="dashboard/report-details"
            element={
              <div className={!navVisible ? "page" : "page page-with-navbar"}>
                <AccountDetails/>
              </div>
            }
          />
        </Route>
        
        
        {/* <Route path='/analytics' element={
						<div className={!navVisible ? "page" : "page page-with-navbar"}>
							<h1>Analystics</h1>
						</div>
					}/>
					<Route path='/orders' element={
						<div className={!navVisible ? "page" : "page page-with-navbar"}>
							<h1>Orders</h1>
						</div>
					}/>
					<Route path='/settings' element={
						<div className={!navVisible ? "page" : "page page-with-navbar"}>
							<h1>Settings</h1>
						</div>
					}/> */}

        {/* <Route 
            path="/customers/dashboard" 
            element={<sidebarRes /> }
          /> */}

        {/* <Route
            path="/customer/personal_loan/:apiKey/:apiSecret"
            element={<OldJourney />}
          /> */}
        <Route
          path="/customized_privacy_policy_for_roopya_in_relation_to_collection_of_information_for_HDFC_Bank"
          element={<HDFCPrivacyPolicy />}
        />
        <Route
          path="/consent_v1_in_relation_to_requested_products"
          element={<ConsentV1 />}
        />
        <Route
          path="/consent_v2_in_relation_to_other_products"
          element={<ConsentV2 />}
        />
        <Route path="*" element={<div>Page not found</div>} />
        {/* <Route path="/credit_card" element={<CreditCard />} /> */}
      </Routes>
    </div>
  );
}
